
export default {
  name: 'NewCard',
  props: {
    name: {
      type: String,
      default: '',
      required: true,
    },
    cardBackground: {
      type: String,
      default: '',
    },
  },
  emits: ['handleClick'],
};
